var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBlog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.71741V15.1797C0 16.1215 0.775679 16.8971 1.71757 16.8971H19.5028L25.2096 21.4953V16.8971V15.7337V1.71741C25.2096 0.775604 24.4339 0 23.492 0H1.71757C0.775679 0 0 0.775604 0 1.71741Z",
    fill: "#0E1E57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27048 10.0364C8.14338 10.0364 8.85101 9.34645 8.85101 8.49537C8.85101 7.64429 8.14338 6.95435 7.27048 6.95435C6.39757 6.95435 5.68994 7.64429 5.68994 8.49537C5.68994 9.34645 6.39757 10.0364 7.27048 10.0364Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4469 10.0364C13.2979 10.0364 13.9879 9.34645 13.9879 8.49537C13.9879 7.64429 13.2979 6.95435 12.4469 6.95435C11.5958 6.95435 10.9058 7.64429 10.9058 8.49537C10.9058 9.34645 11.5958 10.0364 12.4469 10.0364Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7418 10.0364C18.5928 10.0364 19.2828 9.34645 19.2828 8.49537C19.2828 7.64429 18.5928 6.95435 17.7418 6.95435C16.8907 6.95435 16.2007 7.64429 16.2007 8.49537C16.2007 9.34645 16.8907 10.0364 17.7418 10.0364Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlog);
export default __webpack_public_path__ + "static/media/Icon-Blog.89f4d849fdbdc7e4f4ea07998fd6fbf8.svg";
export { ForwardRef as ReactComponent };